import { Injectable } from '@angular/core';
import {
  Router,
  UrlTree,
  ActivatedRouteSnapshot,
  ActivatedRoute,
  NavigationEnd,
  RouteConfigLoadEnd,
  ActivationEnd,
  NavigationStart,
  Route,

} from '@angular/router';
import { ObjectUtils } from 'jul-web-shared-lib';
import { has, isEqual, isNil, isEmpty } from 'lodash';
import { BehaviorSubject, Observable } from 'rxjs';
import { filter, map, mergeMap } from 'rxjs/operators';
import * as _ from 'lodash';
import { Tab } from '../models/tab.model';

@Injectable({
  providedIn: 'root'
})
export class TabService {

  private tabBehavior: BehaviorSubject<Tab> = new BehaviorSubject<Tab>(null);
  private tabs$: BehaviorSubject<Tab[]> = new BehaviorSubject<Tab[]>(null);
  private objUtils = new ObjectUtils();
  currentNavigation = '';

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute) {

    this.router.events.pipe(
      filter((event) => event instanceof NavigationEnd),
      map(() => this.activatedRoute),
      map((route: ActivatedRoute) => {
        while (route.firstChild) { route = route.firstChild; }
        return route;
      }))
      .subscribe((event: ActivatedRoute) => {
        const tab = {
          path: this.router.url,
          outlet: event.outlet,
          label: event.snapshot.data.title,
          data: event.snapshot.data,
          component: event.snapshot.component,
          returnUrl: event.snapshot.queryParams['returnUrl']
        } as Tab;
        this.addOrUpdateTab(tab);
      });

    this.router.events.pipe(
      filter((event) => event instanceof NavigationStart))
      // filter((route) =>  route.outlet === 'primary'),
      // mergeMap((route) => route.data))
      .subscribe((event: NavigationStart) => {
        if (!this.currentNavigation) {
          this.currentNavigation = event.url;
        }
      });

    window.addEventListener('single-spa:first-mount', () => {
      setTimeout(() => {
        if (this.currentNavigation && this.currentNavigation !== this.router.url) {
          this.router.navigateByUrl(this.currentNavigation);
          return;
        }
      }, 1000);
    });


    this.tabBehavior.asObservable()
      .pipe(
        filter((tab: Tab) => !isNil(tab))
      )
      .subscribe((tab: Tab) => {
        let user = JSON.parse(localStorage.getItem('user'));
        let homepage = '/dashboard/page/vessel';

        if (user && user.applicableHomepage && user.applicableHomepage.url) {
          homepage = user.applicableHomepage.url;
        }

        if (tab.path === '/' || tab.path === homepage || tab.path === '/home' || (tab.path.includes('/error'))) { return; }

        let tabs;

        if (!this.tabs$.value && localStorage.getItem('jul_tabs_core')) {
          tabs = JSON.parse(localStorage.getItem('jul_tabs_core'));
        } else {
          tabs = this.tabs$.value;
        }

        let newTabs = null;
        const segments = this.segments(tab.path);
        if (!isEmpty(tabs)) {
          const tabExistsIndex = tabs.findIndex((tb: Tab) => this.arraysEqual(this.segments(tb.path), segments));
          if (!Object.is(-1, tabExistsIndex)) {
            newTabs = _.cloneDeep(tabs);
            newTabs[tabExistsIndex] = tab;
          } else {
            localStorage.setItem('deleteTabStore', tab.path);
            newTabs = [
              ...tabs,
              tab
            ];
          }
          this.tabs$.next(newTabs);
        } else {
          localStorage.setItem('deleteTabStore', tab.path);
          newTabs = [tab];
          this.tabs$.next(newTabs);
        }
      });
  }

  arraysEqual(arr1: any, arr2: any) {
    if (!arr1 || !arr2 || arr1.length !== arr2.length) return false;
    for (var i = arr1.length; i--;) {
      if (arr1[i].path !== arr2[i].path) return false;
    }

    return true;
  }

  tabs(): Observable<Tab[]> {
    return this.tabs$.asObservable();
  }

  removeTab(index: number) {
    if (this.tabs$ && this.tabs$.value) {
      const newTabs = this.tabs$.value.filter((_, idx) => !Object.is(index, idx));
      this.tabs$.next(newTabs);
    }
  }

  addOrUpdateTab(tab: Tab) {
    if (tab && tab.path) {
      if (!tab.path.includes('/authentication')) {
        if ((this.tabs$?.value?.find(x => x.path == tab.path) && tab.label != '')) {
          this.tabBehavior.next(tab);
        }
        else if (!this.tabs$?.value?.find(x => x.path == tab.path)) {
          this.tabBehavior.next(tab);
        }
      }
    }
  }

  private segments(path: string) {
    if (this.router.parseUrl(path).root && this.router.parseUrl(path).root.children &&
      this.router.parseUrl(path).root.children["primary"]) {
      let index = 3;

      // If you need a exception the index is the index number (on url) of your changing id
      if (path.includes('/train-call-management/')) {
        index = 5;
      } else if (path.includes('vm/maneuver-planning')) {
        index = 2;
      } else if (path.includes('regularline')) {
        index = 4;
      }
      return this.router.parseUrl(path).root.children["primary"].segments.slice(0, index);
    }
  }

  getTitle(state, parent) {
    const data = [];
    if (parent && parent.snapshot.data && parent.snapshot.data.title) {
      data.push(parent.snapshot.data.title);
    }

    if (state && parent) {
      data.push(... this.getTitle(state, state.firstChild(parent)));
    }
    return data;
  }

  getSnapshot(state, parent): ActivatedRouteSnapshot {
    let data: ActivatedRouteSnapshot;
    if (parent && parent.snapshot) {
      data = parent.snapshot;
      return data;
    }

    if (state && parent) {
      data = this.getSnapshot(state, state.firstChild(parent));
    }
    return data;
  }



}
